var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"icon":_vm.icon,"color":_vm.color,"width":_vm.width,"height":""}})}
var staticRenderFns = []

export { render, staticRenderFns }